import { useToggleState } from '@cian/react-utils';
import * as React from 'react';

import styles from './AreaPartHeader.css';
import { AreaPartExpandToggle } from './internal/components/AreaPartHeaderExpandButton/AreaPartExpandToggle';
import { AreaPartModal } from '../modals/AreaPartModal/AreaPartModal';
import { AreaPartTitle } from './internal/components/AreaPartTitle/AreaPartTitle';
import { IAreaPartHeaderProps } from './types';

export const AreaPartHeader: React.FC<IAreaPartHeaderProps> = props => {
  const { title, expanded, isTooltipOpened, canDelete, onDelete, onExpand } = props;
  const { state: isModalOpened, toggle: toggleIsModalOpened } = useToggleState(false);

  return (
    <div className={styles['container']}>
      <AreaPartTitle active={canDelete} title={title} onDeleteButtonClick={toggleIsModalOpened} />
      <AreaPartExpandToggle expanded={expanded} onClick={onExpand} isTooltipOpened={isTooltipOpened} />
      <AreaPartModal
        opened={isModalOpened}
        heading="Удаление площади"
        description="Все данные о площади будут удалены"
        approveButtonTitle="Удалить площадь"
        onApproveButtonClick={onDelete}
        onClose={toggleIsModalOpened}
      />
    </div>
  );
};
